// extracted by mini-css-extract-plugin
export default {"container":"Block_container__O80Cn","content":"Block_content__tFjsh","text":"Block_text__9yYn8"};